/**
 * Last/previous close from an ascending close series (ADR-0032 shape).
 *
 * Pure and shared by BOTH adapters on purpose: the header's price change is the
 * one number on the stock screen a user checks against another source, so two
 * implementations of "previous close" is exactly the drift `core` exists to
 * prevent. Takes the bars as an argument rather than reaching for a window.
 */
import type { QuoteClose } from '@meridian/contracts';

export function quoteClose(bars: readonly number[]): QuoteClose | null {
  const lastClose = bars[bars.length - 1];
  if (lastClose === undefined) return null;
  /* `?? null`, never `?? 0` — a single-bar series has no previous close, and a
     close of 0 would be a real observation (R2b). */
  return { lastClose, prevClose: bars[bars.length - 2] ?? null };
}
